import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { type EasyOnboardingBackEvent, IncomingMessageType, type MessageEvent } from './types';

export const MessageHandlerContainer = () => {
    const navigate = useNavigate();
    const receiveEasyOnboardingBackEvent = (event: EasyOnboardingBackEvent) => {
        const url = event?.data?.payload?.url;
        if (url !== undefined && url.trim().length > 0) {
            navigate(url);
        }
    };

    useEffect(() => {
        const listenerCallback = (event: MessageEvent): void => {
            switch (event?.data?.type) {
                case IncomingMessageType.EASY_ONBOARDING_BACK_STATE:
                    receiveEasyOnboardingBackEvent(event);
                    break;
            }
        };
        window.addEventListener('message', listenerCallback, false);
        return (): void => window.removeEventListener('message', listenerCallback, true);
    }, []);

    return null;
};
